import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';

const authUri = environment.identityUrl;

const registrationRequestUri = `${authUri}/Account/ValidateRegistrationRequest`;
const registrationUri = `${authUri}/Account/Registration`;

const emailConfirmationUri = `${authUri}/Account/EmailConfirmation`;

const clientUri = environment.clientUrl;

const apiUri = environment.apiUrl;
const profileUri = apiUri + '/api/Profile';

const redisUri = `${environment.redisUrl}/api/Redis`;

@Injectable({
  providedIn: 'root'
})
export class ConstService {

  readonly recaptchaSiteKey = '6Ld5Vw4aAAAAAL7lj7orDFhDzCUDZm4xdsIQikVp';

  readonly usersManagementApiUri = `${authUri}/Admin`;
  readonly formDataUri = `${this.usersManagementApiUri}/GetFormDataAndStatistics`;
  readonly usersUri = `${this.usersManagementApiUri}/GetUsers`;
  readonly searchByUsernameOrEmailUri = `${this.usersManagementApiUri}/SearchByUsernameOrEmail`;
  readonly searchByRoleIdUri = `${this.usersManagementApiUri}/SearchByRoleId`;
  readonly searchByIdUri = `${this.usersManagementApiUri}/SearchById`;
  
  readonly userChangesUri = `${this.usersManagementApiUri}/SaveUserChanges`;
  readonly sendingMailUri = `${this.usersManagementApiUri}/SendEmail`;
  readonly identifiersUri = `${this.usersManagementApiUri}/GetIdentifiers`;
  readonly newAccountUri = `${this.usersManagementApiUri}/AddUser`;
  readonly resetPasswordUri = `${this.usersManagementApiUri}/ResetPassword`;

  readonly accountUri = `${authUri}/Account`;
  readonly changePasswordRequestUri = `${this.accountUri}/ChangePasswordRequest`;
  readonly changePasswordUri = `${this.accountUri}/ChangePassword`;
  readonly changeEmailUri = `${this.accountUri}/ChangeEmail`;

  constructor() { }

  getAuthUri() {
    return authUri;
  }

  getClientUri() {
    return clientUri;
  }

  getApiUri() {
    return apiUri;
  }

  getRedisUri() {
    return redisUri;
  }

  registrationRequestUri = () => registrationRequestUri;
  registrationUri = () => registrationUri;

  getProfileUri() {
    return profileUri;
  }

  emailConfirmationUri() {
    return emailConfirmationUri;
  }

}
